import { Center, Spinner } from '@chakra-ui/react';
import useAccountIdQueryParam from 'hooks/modules/brokerAccount/useAccountIdQueryParam';
import usePeriodQueryParam from 'hooks/modules/period/usePeriodQueryParam';
import PortfolioAccountList from 'presentation/components/modules/portfolio/PortfolioAccountList';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';
import { useFetchPortfolioQuery } from 'rtkQuery/sharespro/queries/portfolio';

const PortfolioAccountsContainer: FC = () => {
  const { t } = useTranslation();
  const [accountId, setAccountId] = useAccountIdQueryParam();
  const [period] = usePeriodQueryParam();
  const { data, error, refetch, isFetching } = useFetchPortfolioQuery({
    period,
    account_id: accountId,
  });

  const location = useLocation();

  const navigate = useNavigate();

  const navigateOnTap = !new Set([
    AppRoute.portfolio,
    AppRoute.operationsPath,
  ]).has(location.pathname);

  const wrapByCard = !data;
  let content;
  if (data) {
    content = (
      <PortfolioAccountList
        refetch={() => {
          refetch();
        }}
        onTotalClick={() => {
          if (navigateOnTap) {
            navigate(AppRoute.portfolio);
          } else {
            setAccountId(undefined);
          }
        }}
        onAccountClick={(next) => {
          if (navigateOnTap) {
            navigate(`${AppRoute.portfolio}?account_id=${next}`);
          } else {
            setAccountId(next);
          }
        }}
        total={data.accounts.total}
        items={data.accounts.items}
        activeAccountId={accountId}
        showSelectedAccount={!navigateOnTap}
      />
    );
  } else if (isFetching) {
    content = <Spinner />;
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }
  if (wrapByCard) {
    content = (
      <AppCard p="20">
        <Center>{content}</Center>
      </AppCard>
    );
  }

  return (
    <>
      <GridHeading>{t('navAccounts')}</GridHeading>
      {content}
    </>
  );
};

export default PortfolioAccountsContainer;
